// extracted by mini-css-extract-plugin
export default {"countries":"NrGnshV","centeredCell":"it28oD0","link":"h6X_hlE"};